import { Layout } from "components/Layout/Layout.styled";
import { Paragraph, Title } from "components/Text";
import React from "react";

const Solicitud = () => {
  return (
    <Layout
      className="pt-5 text-center d-flex align-items-center justify-content-center"
    >
      <div className="container">
        <Title className="h1">Solicitud de Registro</Title>
        <Paragraph>Atención! Está página aún está en construcción.</Paragraph>
      </div>
    </Layout>
  );
};

export default Solicitud;
